export default "__VITE_ASSET__DbkcrGfY__"